import { useState } from 'react'
import { toast } from 'sonner'

import { RichTextareaWithSubmit } from '@/components/composer/RichTextareaWithSubmit'
import { Button } from '@/components/ui/button'
import { parseError } from '@/lib/errors'
import { useAddCustomerNote } from '@/models/salesLead'

interface CustomerNoteComposerProps {
  orgId: string
  /** After the note is added, or on Cancel. */
  onClose: () => void
}

/** Writes a note onto the timeline of a customer without a sales lead. */
export function CustomerNoteComposer({ orgId, onClose }: CustomerNoteComposerProps) {
  const [note, setNote] = useState('')
  const addNote = useAddCustomerNote(orgId)

  return (
    <RichTextareaWithSubmit
      value={note}
      onValueChange={setNote}
      placeholder="Add notes..."
      onSubmitMessage={({ message }) =>
        addNote.mutate(message, { onSuccess: onClose, onError: (error) => toast.error(parseError(error)) })
      }
      buttonProps={{ disabled: addNote.isPending }}
      addonChildren={
        <Button variant="ghost" size="sm" onClick={onClose}>
          Cancel
        </Button>
      }
    />
  )
}
